import { V3Record } from 'data/helpers/V3Record.js'

export const Photo = V3Record('photo', {
  id: null,
  caption: null,
  capturedAt: null,
  createdAt: null,
  groupMembershipId: null,
  height: null,
  lat: null,
  lng: null,
  optionalUuid: null,
  position: null,
  published: true,
  updatedAt: null,
  userId: null,
  visibility: null,
  width: null
})
